import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0c-.6 0-1 .39-1 .977v3.91c0 .587.4.978 1 .978s1-.39 1-.977V.978C12 .391 11.6 0 11 0m0 15.641c-.6 0-1 .391-1 .978v3.91c0 .587.4.978 1 .978s1-.392 1-.978v-3.91c0-.587-.4-.978-1-.978M4.6 3.128a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369L6 7.233c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369zm11.3 11.047a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l2.8 2.737c.2.196.5.294.7.294s.5-.098.7-.294a.93.93 0 0 0 0-1.368zM6 10.753c0-.586-.4-.978-1-.978H1c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h4c.6 0 1-.391 1-.978m15-.978h-4c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h4c.6 0 1-.391 1-.978 0-.586-.4-.978-1-.978m-14.9 4.4-2.8 2.737a.93.93 0 0 0 0 1.369c.2.195.5.293.7.293s.5-.098.7-.293l2.8-2.738a.93.93 0 0 0 0-1.368c-.4-.391-1.1-.391-1.4 0m9.1-6.55c.3 0 .5-.098.7-.293l2.8-2.738a.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0l-2.8 2.737a.93.93 0 0 0 0 1.369c.2.195.5.293.7.293"
    }, null, -1)
  ]))]))
}
export default { render: render }